// src/pages/AttendancePage/ControlAttendanceCard/ControlAttendanceCard.tsx
import React, { useEffect, useState } from "react";
import { ZeusButton, ZeusTextInput, ZeusTypography } from "zeus-front-design-system";
import * as styles from "./ControlAttendanceCard.module.scss";

import { useBiometric } from "../../../Context/Biometric/biometric.Context";
import capitalize from "../../../utils/capitalize";
import timeGreeting from "../../../utils/timeGreeting";
import AttendanceShell from "../../../componets/AttendanceShell/AttendanceShell";

interface ControlAttendanceCardProps {
  empId: string;
  setEmpId: (id: string) => void;
  canSubmit: boolean;
  handleSubmit: (e: React.FormEvent) => void;
  error?: string | null;
}

const MessageWithValidationPhoto: React.FC = () => (
  <ZeusTypography type={"Body"} size="small" style="bold" component="p" className={styles.helpText}>
    Para registrar tu asistencia es necesario tu identificador Zeus. Si no lo tienes, revisa la app o solicita apoyo a tu administrador
  </ZeusTypography>
);

export const MessageIdColaborator: React.FC = () => (
  <ZeusTypography type={"Body"} size="small" style="bold" component="p" className={styles.helpText}>
    Para registrar tu asistencia es necesario tu identificador Zeus. Si no lo tienes, revisa la app
    o solicita apoyo a tu administrador.
  </ZeusTypography>
);

const ControlAttendanceCard: React.FC<ControlAttendanceCardProps> = ({
  empId,
  setEmpId,
  canSubmit,
  handleSubmit,
  error = null,
}) => {
  const { biometrics } = useBiometric();
  const [helpNode, setHelpNode] = useState<React.ReactNode>(null);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (biometrics?.take_photo) {
      setHelpNode(<MessageWithValidationPhoto />);
    } else {
      setHelpNode(<MessageIdColaborator />);
    }

    return () => {
      setHelpNode(null);
    };
  }, [biometrics]);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const header = (
    <ZeusTypography
      component="h1"
      type="Headline"
      style="bold"
      size="medium"
      color="#262626"
      className={styles.greeting}
    >
      {"¡" + capitalize(timeGreeting(now)) + "! 👋"}
    </ZeusTypography>
  );

  return (
    <AttendanceShell
      header={header}
      subtitle="Realiza el registro de hoy."
      helpNode={helpNode}
      timeFormat="24h"
      dividerText="Ingresa tu número de empleado"
      isLoagout
    >
      <form onSubmit={handleSubmit} className={styles.form} noValidate>
        <div className={styles.inputWithError}>
          <ZeusTextInput
            value={empId}
            onChange={(e) => setEmpId(e.target.value)}
            placeholder={"--"}
            contextualTextPosition={"top"}
            contextualText="Num. empleado (ID)"
            width="100%"
            counterValidation={{ visible: false, maxLength: 0 }}
            className={styles.input}
          />
          {error && (
            <ZeusTypography className={styles.error} style="normal" color="error" type="Body">
              {error}
            </ZeusTypography>
          )}
        </div>
        <ZeusButton
          type="submit"
          textContent="Continuar"
          disabled={!canSubmit && !error}
          withArrow={false}
          className={styles.submitButton}
          styles={{ width: "100%", height: 38 }}
        />
      </form>
    </AttendanceShell>
  );
};

export default ControlAttendanceCard;
